import { useState, type Dispatch, type SetStateAction, useMemo } from 'react';

import type { UseQueryResult } from '@tanstack/react-query';
import useEvent from 'react-use-event-hook';

const empty = Symbol.for('');

/**
 *
 * @param query
 * @param map
 * @returns
 * When setState is not called, return the query data as the state; else, return the local state.
 * Useful if you want to initialize the state from the query.
 */
export const useStateFromQuery = <TData = unknown, TState = TData, TError = unknown>(
  query: UseQueryResult<TData, TError>,
  map: (data?: TData) => TState,
): [TState, Dispatch<SetStateAction<TState>>] => {
  const mapped = useMemo(() => map(query.data), [query.data]);

  const [state, setState] = useState<any>(empty);

  return [
    state === empty ? mapped : state,
    useEvent((next) => {
      setState((cur: any) => {
        return typeof next === 'function' ? (next as any)(cur === empty ? mapped : cur) : next;
      });
    }),
  ];
};
